/**
 * Line Item Controller
 * This controller is required to handle functionality within
 * the scope of individual line items in teh quick-cart.
 */

import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["quantity", "itemTotalPrice", "increase", "decrease"];
  static values = { variant: String, key: String };

  connect() {
    if (this.hasQuantityTarget) {
      this.quantity = parseInt(this.quantityTarget.value);
      this.inventoryPolicy = this.quantityTarget.dataset.inventoryPolicy;
    }
  }

  async increaseQuantity() {
    if (this.hasQuantityTarget) {
      this.quantity = this.quantity + 1;
      // Perform the update with shopify api
      const data = await this.updateQuantityRequest(this.quantity);

      if (data) {
        this._updatePrice(data);
        this.quantityTarget.value = this.quantity;
        if (this.quickCartController) {
          this.quickCartController.updateBasketTotal(data);
        }
      }
    }
  }

  async decreaseQuantity() {
    if (this.hasQuantityTarget) {
      if (this.quantity > 1) {
        this.quantity = this.quantity - 1;
        this.element.dataset.quantity = this.quantity;
      }

      if (this.quantity <= 1) {
        this.decreaseTarget.setAttribute("disabled", true);
      } else {
        this.decreaseTarget.removeAttribute("disabled");
      }

      this.quantityTarget.value = this.quantity;
      const data = await this.updateQuantityRequest(this.quantity);
      if (data) {
        this._updatePrice(data);

        if (this.quickCartController) {
          this.quickCartController.updateBasketTotal(data);
        }
      }
    }
  }

  _updatePrice(data) {
    const item = data.items.find((item) => item.key === this.keyValue);
    if (item) {
      this.itemTotalPriceTarget.innerText = `${
        document.body.dataset.currency
      }${(item.final_line_price / 100).toFixed(2)}`;
    }

    if (this.cartController) {
      this.cartController.handleSubtotal(data);
    } else if (this.quickCartController) {
      this.quickCartController.handleSubtotal(data);
    }
  }

  async removeFromCart() {
    const data = await this.updateQuantityRequest(0);

    if (this.cartController) {
      this.cartController.handleSubtotal(data);
    } else if (this.quickCartController) {
      this.quickCartController.handleSubtotal(data);
      this.quickCartController.updateBasketTotal(data);
      this.element.remove();
      this.quickCartController.setMessage();
    }
  }

  async updateQuantityRequest(quantity) {
    try {
      const res = await fetch("/cart/change.js", {
        method: "post",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: this.keyValue || this.variantValue,
          quantity,
        }),
      });

      const data = await res.json();
      if (res.ok) {
        if (this.quickCartController && window.location.pathname !== "/cart") {
          this.quickCartController.handleLineItemStock(quantity, this.element);
        }

        return data;
      } else {
        return alert(data.description);
      }
    } catch (err) {
      console.error("Error Updating Quantity:", err);
    }
  }

  get productController() {
    return this.application.controllers.find((controller) => {
      return controller.context.identifier === "product";
    });
  }

  get cartController() {
    return this.application.controllers.find((controller) => {
      return controller.context.identifier === "cart";
    });
  }

  get quickCartController() {
    return this.application.controllers.find((controller) => {
      return controller.context.identifier === "quick-cart";
    });
  }
}
